export const lottery = {
  tripletaRetrySamePurchase:
    "The purchase could not be confirmed. Retry this same bet to recover or complete it without creating a duplicate.",
  tripletaLoadError: "Tickets could not be loaded.",
  tripletaRetry: "Retry",
  tripletaPrevious: "Previous",
  tripletaNext: "Next",
  tripletaTicketTypes: "Ticket type",
  tripletaClassicTickets: "Classic lottery",
  lotteryPlay: "Play",
  lotteryResults: "Results",
  myLotteryTicket: "My Tickets",
  lotteryMyTickets: "My Lottery Tickets",
  lotteryBackBtn: "Back to Lotteries",
  lotteryMyBets: "My Bets",
  lotteryFloatButtonTitle: "Bets",
  lotteryTooltipText: "Show all my bets",
  lotteryDraw: "Draw",
  lotteryAnimal: "Animal",
  lotterySelectAnimal: "Select an animal",
  lotterySelectDraw: "Select a draw",
  lotteryAmount: "Amount",
  lotteryTotalBet: "Total Bet",
  lotteryBuyTicket: "Buy Ticket",
  lotteryCreateTicket: "Creating ticket",
  lotteryCreatedTicket: "Ticket(s) created successfully!",
  lotteryErrorTicket: "Error creating the ticket",
  lotteryHideResults: "Hide Results",
  lotteryShowResults: "Show Results",
  lotteryDrawActive: "Active Draw",
  lotteryErrorLoadingData: "Error loading data",
  lotteryErrorInput: "Please add at least one bet before playing.",
  lotteryErrorBalance: "Insufficient balance. Please reload your balance.",
  lotteryErrorBetAmount: "The minimum bet is R 50",
  lotteryErrorMinBetAmount: "Minimum bet is R {{min}}",
  lotteryErrorMaxBetAmount: "Maximum bet is R {{max}}",
  lotteryErrorBetStep: "Bets must be in multiples of {{step}} (50, 60, 70...).",
  lotteryBetHintMin: "Min {{min}} Bs",
  lotteryBetHintStep: "multiples of {{step}}",
  lotteryBetHintMax: "max {{max}} Bs",
  lotteryErrorSelectDrawAnimal: "Please select a draw, an animal and enter a valid bet amount.",
  lotteryMode: "You can only select up to 4 animals in Modern mode.",
  lotteryTicketCreatedMessage: "Ticket created successfully",
  lotteryTicketCreatedMessageError: "Error creating the ticket",
  lotteryCardGame: "Coming Soon",
  lotteryModalCode: "Ticket Code",
  lotteryModalDate: "Creation Date",
  lotteryModalTotal: "Total Amount",
  lotteryModalWon: "Won Amount",
  lotteryModalAnimals: "Played Animals",
  lotteryModalTitle: "Ticket Details",
  lotteryModalCancel: "Cancel",
  lotteryModalConfirm: "Accept",
  lotteryModalAmount: "Amount",
  lotteryModalNoTickets: "You don't have lottery tickets",
  lotteryTokenNotFound: "Token not found",
  lotteryActiveRouletteResults: "Active Roulette Results",
  lotteryGameWinner: "Winner",
  lotteryGamePrize: "No winners",

  lotteryModalInput: "Enter your bet amount",
  lotteryModalAddBet: "Add Bet",
  lotteryModalCancelBet: "Cancel",

  lotteryTraditional: "Traditional",
  lotteryModern: "Modern",
  selectLotteryType: "Select Lottery Type",
  results: "Results",
  resultLotteryModern: "Modern Lottery Result",
  resultLotteryTradicional: "Traditional Lottery Result",
  lotteryDate: "Lottery Date",
  lotteryNoResults: "No results available for this date",

  // ── Tripleta (modalidad) ──
  tripleta: "Tripleta",
  tripletaTitle: "Tripleta",
  tripletaSubtitle:
    "Pick 3 figures of a game. If they all come out in the next {{n}} draws, you win amount × multiplier.",
  tripletaStep1: "1. Choose the lottery",
  tripletaStep2: "2. Pick 3 figures",
  tripletaPays: "pays {{factor}}×",
  tripletaFiguresCount: "{{count}} figures",
  tripletaNextDraw: "Next draw {{time}}",
  tripletaSelectedCount: "{{count}} of 3",
  tripletaDrawsPanel: "Draws you play",
  tripletaDrawsHint: "Your ticket plays these {{n}} draws. Sales close minutes before the first one.",
  tripletaTomorrow: "tomorrow",
  tripletaContinue: "Continue",
  tripletaClear: "Clear",
  tripletaVerify: "Review your bet",
  tripletaEnterAmount: "Enter the amount",
  tripletaCustomAmount: "Other amount",
  tripletaAmountRules: "Minimum {{min}} · multiples of {{step}}",
  tripletaPotentialPrize: "Potential prize",
  tripletaAccept: "ACCEPT",
  tripletaCancel: "CANCEL",
  tripletaBuying: "Buying…",
  tripletaBought: "Tripleta purchased!",
  tripletaBoughtDetail: "Your 3 figures play the next {{n}} draws of {{game}}.",
  tripletaSeeMine: "See my tripletas",
  tripletaPlayAgain: "Play another",
  tripletaMyTickets: "My tripletas",
  tripletaNoTickets: "You have no tripletas yet",
  tripletaStatusOpen: "Open",
  tripletaStatusWon: "Won",
  tripletaStatusLost: "Lost",
  tripletaStatusVoid: "Cancelled",
  tripletaHits: "{{hits}} of 3 hits",
  tripletaRemaining: "{{n}} draws left",
  tripletaCanStillWin: "You can still win",
  tripletaCannotWin: "Can no longer complete the 3",
  tripletaPrize: "Prize",
  tripletaCancelTicket: "Cancel ticket",
  tripletaCancelConfirm: "The ticket is voided and the amount refunded. Only possible before the first draw closes.",
  tripletaCancelled: "Ticket cancelled and refunded",
  tripletaUnavailable: "Tripleta is not available right now",
  tripletaWindowUnavailable: "Not enough upcoming draws for this game",
  tripletaErrSaleClosed: "The first draw already closed. We refreshed the draws, check and try again.",
  tripletaErrComboLimit: "This combination reached today's cap. Try another one.",
  tripletaErrInsufficient: "Insufficient balance for this tripleta.",
  tripletaErrInvalidSelection: "You must pick 3 different figures.",
  tripletaErrInvalidAmount: "Invalid amount. Check the minimum and step.",
  tripletaErrRateLimited: "Too many purchases in a row, wait a moment.",
  tripletaErrGeneric: "Could not buy the tripleta. Try again.",
  tripletaDeposit: "Top up balance",
  tripletaHowTitle: "How does it work?",
  tripletaHow1: "Choose a lottery and 3 different figures.",
  tripletaHow2: "Your ticket takes part in the next {{n}} draws of that lottery.",
  tripletaHow3: "Each time one of your figures comes out it gets a ✓. With all 3 marked, you win.",
  tripletaHow4: "The prize is your amount × the lottery multiplier, credited instantly.",
  tripletaResultPending: "Pending",
  tripletaResultCame: "Came out {{n}}",
  tripletaSearch: "Search animal or number",
  tripletaSearchPlaceholder: "E.g. Lion or 05",
  tripletaShowAll: "Show all",
  tripletaNoFigures: "No animals found. Try another name or number.",
  tripletaViewDraws: "View all {{count}} draws",

  lastPlaysTitle: "Your recent plays",
  lastPlaysSubtitle: "Your trusted plays, one tap away",
  lastPlaysPrev: "Previous",
  lastPlaysNext: "Next",
  lastPlaysRepeat: "Repeat",
  lastPlaysSelections: "selections",
  lastPlaysModalTitle: "Repeat play",
  lastPlaysModalAria: "Repeat play",
  lastPlaysSelectDraw: "Draw time",
  lastPlaysNoDraws: "No draws available",
  lastPlaysAmountLabel: "Amount per selection",
  lastPlaysAmountPlaceholder: "Optional",
  lastPlaysPerBetNote: "Original amounts will be used ({{total}} Bs total). Enter an amount to unify.",
  lastPlaysTotalHint: "Total: {{total}} Bs ({{count}} selections)",
  lastPlaysConfirm: "Confirm — {{total}} Bs",
  lastPlaysSuccessTitle: "Play repeated!",
  lastPlaysSuccessAmount: "Total: {{amount}} Bs",
  lastPlaysClose: "Close",
  lastPlaysInvalidAmount: "Invalid amount",
};
